import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase";

export default function PostCard({ id, title, author, authorPhoto, date, preview, likedBy = [], isOwner = false, onDelete, isPinned = false }) {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [isLiked, setIsLiked] = useState(false);
  const [likesCount, setLikesCount] = useState(likedBy ? likedBy.length : 0);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((currentUser) => {
      setUser(currentUser);
      if (currentUser && likedBy) {
        setIsLiked(likedBy.includes(currentUser.uid));
      }
    });
    return () => unsubscribe();
  }, [likedBy]);

  const handleOpen = () => {
    navigate(`/post/${id}`);
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    if (onDelete) {
      onDelete(id);
    }
  };

  return (
    <div 
      className="post-list-item" 
      onClick={handleOpen} 
      style={{ 
        display: "flex", 
        alignItems: "center", 
        padding: "12px 16px", 
        borderBottom: "1px solid #eee", 
        cursor: "pointer",
        transition: "background-color 0.2s",
        backgroundColor: isPinned ? "#fff9db" : "transparent" // 고정글 배경색 강조
      }}
      onMouseEnter={(e) => e.currentTarget.style.backgroundColor = isPinned ? "#fff3bf" : "#f8f9fa"}
      onMouseLeave={(e) => e.currentTarget.style.backgroundColor = isPinned ? "#fff9db" : "transparent"}
    >
      {/* 제목 */}
      <div style={{ flex: 1, fontWeight: "bold", fontSize: "1rem", color: "#333", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", marginRight: "16px", display: "flex", alignItems: "center" }}>
        {isPinned && <span style={{ marginRight: "6px", fontSize: "0.85rem", padding: "2px 6px", borderRadius: "4px", backgroundColor: "#fff0f6", color: "#e64980", border: "1px solid #ffdeeb" }}>📌 필독</span>}
        {title}
      </div>

      {/* 작성자 */}
      <div style={{ display: "flex", alignItems: "center", width: "120px", marginRight: "16px" }}>
        <img 
          src={authorPhoto || "https://via.placeholder.com/36"} 
          alt="author" 
          style={{ width: "24px", height: "24px", borderRadius: "50%", marginRight: "8px", objectFit: "cover" }}
        />
        <span style={{ fontSize: "0.9rem", color: "#495057", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{author}</span>
      </div>

      {/* 날짜 */}
      <div style={{ width: "100px", fontSize: "0.85rem", color: "#868e96", textAlign: "center", marginRight: "16px" }}>
        {date}
      </div>

      {/* 좋아요 및 삭제 */}
      <div style={{ display: "flex", alignItems: "center", gap: "12px", minWidth: "80px", justifyContent: "flex-end" }}>
        <span 
          style={{ fontSize: "0.9rem", color: isLiked ? "red" : "#adb5bd", display: "flex", alignItems: "center", gap: "4px" }}
        >
          {isLiked ? "❤️" : "🤍"} {likesCount}
        </span>
        
        {isOwner && (
          <button 
            onClick={handleDelete}
            style={{ background: "none", border: "none", color: "#fa5252", fontSize: "0.85rem", cursor: "pointer", padding: "4px 8px" }}
          >
            삭제
          </button>
        )}
      </div>
    </div>
  );
}
